module.exports = __webpack_public_path__ + "static/media/car_icon.a7d4cb19.svg";